var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder-card card bg-light d-flex justify-content-center align-items-center h-100"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }